import { format, getTime, formatDistanceToNow } from 'date-fns';
import moment from 'moment'
// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy p';

  return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}

export const onGetDateFormat = (data, format) => {
  if(!data) return null
  const momentdata = moment(data)
  if(!momentdata.isValid()) return null
  if(format) return momentdata.format(format)
  return momentdata.format('YYYY-MM-DD')
}

export const onGetDateWithTimezone = (data, format) => {
  // This function returns a moment object
  if(!data) return null 
  const temp = moment.utc(data)
  if(!temp.isValid()) return null 
  //console.log(moment.utc(data).format())
  if(!format) return moment(temp.format())

  return moment(temp.format()).format(format)
  
}

export const getDateAddTZFormat = (datein, formatPattern) => {
  if (!datein || datein === "") return "";

  const date = typeof datein === "string" || typeof datein === "number"
    ? new Date(datein)
    : datein;

  const timezoneOffset = date.getTimezoneOffset() * 60 * 1000;
  const adjustedDate = new Date(date.getTime() + timezoneOffset);

  return format(adjustedDate, formatPattern || "dd MMM yy");
};

export function getTimetoUserLocalUtcFormat(dateString, addOneDay) {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Parse input and optionally add 1 day
  const baseDate = new Date(`${dateString}T00:00:00`);
  if (addOneDay) {
    baseDate.setDate(baseDate.getDate() + 1);
  }

  // Format to local string in user's time zone
  const localString = baseDate.toLocaleString('en-US', { timeZone });
  const localDate = new Date(localString);

  return new Date(localDate.getTime()).toISOString();
}